/**
 * Превращает объект с вложенными ключами в плоский.
 * @param  object ob объект со значениями
 * @return object    плоский объект со значениями
 */
function flattenObject(ob) {
    var toReturn = {};

    for (var i in ob) {
        if (!ob.hasOwnProperty(i)) continue;

        if ((typeof ob[i]) == 'object' && ob[i] !== null) {
            var flatObject = flattenObject(ob[i]);
            for (var x in flatObject) {
                if (!flatObject.hasOwnProperty(x)) continue;

                toReturn[i + '-' + x] = flatObject[x];
            }
        } else {
            toReturn[i.replaceAll('_', '-')] = ob[i];
        }
    }
    return toReturn;
}

/**
 * Ищет на странице элементы с совпадающим атрибутом и вставляет в него текст
 * @param object data   плоский массив с ключом-именем атрибута для вставки и значением
 * @param string prefix префикс атрибута на странице, означающую сущность, например: "selected-office"
 */
function setDataAttributes(data, prefix, parentElement) {
    for (let key in data) {
        let value = data[key];
        let attributeName = `data-nika-${prefix}-${key}`;

        if (!parentElement) {
            var elementsList = document.querySelectorAll(`[${attributeName}]`);
        } else {
            var elementsList = parentElement.querySelectorAll(`[${attributeName}]`);
        }
        elementsList.forEach(function(elementItem) {
            if (attributeName.indexOf('phone') > 0 && value !== undefined) {
                let phone = value.replace(/(\s|\(|\)|\-)/g, '');
                elementItem.href = `tel:${phone}`;
            }
            if (attributeName.indexOf('img') > 0 || attributeName.indexOf('logo') > 0) {
                if (value !== undefined && value !== null) {
                    elementItem.src = value;
                    elementItem.style.display = 'block';
                } else {
                    elementItem.style.display = 'none';
                    elementItem.src = null;
                }
                return;
            }
            if (attributeName.indexOf('url') > 0 && value !== undefined) {
                elementItem.href = elementItem.href.replace(/\/[^\/]*$/, `/${value}`);
                return;
            }
            if (elementItem.parentNode.style.display === 'none') {
                elementItem.parentNode.style.display = 'flex';
            }
            elementItem.textContent = value;
        }, attributeName, value);
    }
    return parentElement;
}

function flatObjectSetDataAttributes(ob, prefix) {
    let data = flattenObject(ob);
    setDataAttributes(data, prefix);
}

export { flattenObject, setDataAttributes, flatObjectSetDataAttributes };
